import insightsMerchantEnabled from '@/actions-permission/insights.permissions'

const HOME = ({ permissionIsEnabled, componentIsEnabled }) => {
  return {
    key: 'home',
    routeName: 'home',
    label: 'sidemenu.home',
    showSection: insightsMerchantEnabled(
      permissionIsEnabled,
      componentIsEnabled
    )
  }
}

export default HOME
